var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef, useEffect } from 'react';
import { fscrub } from 'fpoint';
import combineRefs from './lib/combine-refs';
import { createHandlerProxy } from './common';
var scrubOptions = {
    touch: true,
    mouse: true,
};
var hoverOptions = {
    touch: false,
    mouse: false,
    hover: true,
};
var Scrub = forwardRef(function Scrub(props, ref) {
    var _a = props.component, HostComponent = _a === void 0 ? 'div' : _a, style = props.style, onScrubStart = props.onScrubStart, onScrubMove = props.onScrubMove, onScrubEnd = props.onScrubEnd, onHoverStart = props.onHoverStart, onHoverMove = props.onHoverMove, onHoverEnd = props.onHoverEnd, rest = __rest(props, ["component", "style", "onScrubStart", "onScrubMove", "onScrubEnd", "onHoverStart", "onHoverMove", "onHoverEnd"]);
    var handlers = {
        onScrubStart: onScrubStart,
        onScrubMove: onScrubMove,
        onScrubEnd: onScrubEnd,
        onHoverStart: onHoverStart,
        onHoverMove: onHoverMove,
        onHoverEnd: onHoverEnd,
    };
    var innerRef = useRef(null);
    var handlersRef = useRef(handlers);
    handlersRef.current = handlers;
    var proxyHandler = createHandlerProxy(handlersRef.current);
    useEffect(function () {
        var dom = innerRef.current;
        var releaseScrub = fscrub(dom, {
            onStart: proxyHandler('onScrubStart'),
            onMove: proxyHandler('onScrubMove'),
            onEnd: proxyHandler('onScrubEnd'),
        }, scrubOptions);
        var releaseHover = fscrub(dom, {
            onStart: proxyHandler('onHoverStart'),
            onMove: proxyHandler('onHoverMove'),
            onEnd: proxyHandler('onHoverEnd'),
        }, hoverOptions);
        return function () {
            releaseScrub();
            releaseHover();
        };
    }, []);
    return (React.createElement(HostComponent, __assign({}, rest, { ref: combineRefs(ref, innerRef), style: __assign(__assign({}, style), { touchAction: 'none' }) })));
});
Scrub.defaultProps = {
    onScrubStart: function () { },
    onScrubMove: function () { },
    onScrubEnd: function () { },
    onHoverStart: function () { },
    onHoverMove: function () { },
    onHoverEnd: function () { },
};
export default Scrub;
